import computeTimeline from "./compute-timeline";

/**
 * Get all active triggers and compute their flat values
 * @param {MainClassProps} main
 * @param {Number} now
 */
const computeActiveTriggers = (main, now) => {
  const store = main.store;

  /** Set of active trigger names (strings) */
  const triggers = main.activeTriggers;

  /** All active properties of all active triggers of the current element */
  const actives = main.activeProperties;

  /** Loop trough all active triggers in the current step */
  for (const name of triggers) {
    /** @type {TemporaryDataProps} */
    const data = new Map();

    /** Get the desired trigger form the store */
    const trigger = /** @type {TriggerProps} */ (store.get(name));

    /** Timeline */
    const timeline = /** @type {TimelineMapProps} */ (trigger.get("timeline"));

    data.set("main", main);
    data.set("trigger", trigger);
    data.set("timeline", timeline);
    data.set("actives", actives);

    /** Interval timeline */
    computeTimeline(data, now);
  }
};

export default computeActiveTriggers;
